<template>
  <div class="header">
    <router-link to="/" class="logo">
      <img :src="logoImg" alt="" />
    </router-link>
    <div class="menu-container">
      <div class="cursor" ref="cursor"></div>
      <div class="cursor" ref="cursor-current"></div>
      <ul class="menu">
        <li
          @click.self="topage(0, '/')"
          @mouseenter.self="hover(0)"
          @mouseleave="leave(0)"
          :class="[languageText === 'English' ? 'en-li' : '']"
        >
          {{ $t("header[0]") || "首页" }}
        </li>
        <li
          @mouseenter.self="hover(1)"
          @mouseleave="leave(1)"
          :class="[languageText === 'English' ? 'en-li' : '']"
        >
          {{ $t("header[1]") || "产品家族" }}
          <div class="childs">
            <div
              class="prod"
              @click.self="topage(1, '/thirdService/healthPlan')"
            >
              {{ $t("header[7]") || "企业健康管理方案" }}
            </div>
            <div
              class="prod"
              @click.self="topage(1, '/thirdService/healthPlan')"
            >
              {{ $t("header[9]") || "企业定制方案" }}
            </div>
            <div class="prod" @click.self="topage(1, '/products/personal')">
              {{ $t("header[8]") || "个人健康管理方案" }}
            </div>
            <div v-if="!enLang" class="prod" @click.self="topage(1, '/productDetails/DBXYB2024')">
              {{ $t("AMG[9]") || "新燕宝" }}
            </div>
            <div v-if="!enLang" class="prod" @click.self="topage(1, '/productDetails/DBXYBHYB')">
              {{ $t("AMG[10]") || "喜燕宝" }}
            </div>
            <div v-if="!enLang" class="prod" @click.self="topage(1, '/productDetails/DB_BJ_033')">
              {{ $t("header[12]") || "福燕宝" }}
            </div>
            <div v-if="!enLang" class="prod" @click.self="topage(1, '/productDetails/ZLXYB')">
              {{ $t("AMG[12]") || "小燕宝" }}
            </div>
            <div class="prod" @click.self="topage(1, '/productDetails/ZLZRY2023')">
              {{ $t("AMG[13]") || "臻荣耀" }}
            </div>
            <div v-if="!enLang" class="prod" @click.self="topage(1, '/productDetails/DB_BJ_024')">
              {{ $t("AMG[27]") || "臻合意" }}
            </div>
            <div v-if="!enLang" class="prod" @click.self="topage(1, '/productDetails/DBZGD')">
              {{ $t("AMG[26]") || "臻高端" }}
            </div>
            <div v-if="!enLang" class="prod" @click.self="topage(1, '/productDetails/DB_BJ_014')">
              {{ $t("AMG[28]") || "喜燕宝全球版" }}
            </div>
            <div v-if="!enLang" class="prod" @click.self="topage(1, '/productDetails/DB_BJ_034')">
              {{ "欧思脉" }}
            </div>
            <div v-if="!enLang" class="prod" @click.self="topage(1, 'MedilinkGlobalAssist')">
              {{ $t("AMG[29]") || "中间带救援" }}
            </div>
          </div>
        </li>
        <li
          @mouseenter.self="hover(2)"
          @mouseleave="leave(2)"
          :class="[languageText === 'English' ? 'en-li' : '']"
        >
          {{ $t("header[2]") || "第三方管理服务" }}
          <div class="childs">
            <div
              class="prod"
              @click.self="topage(2, '/thirdService/thirdPartService')"
            >
              {{ $t("header[15]") || "第三方服务管理" }}
            </div>
            <div class="prod" @click.self="topage(2, '/vipService')">
              {{ $t("header[16]") || "会员服务" }}
            </div>
            <div class="prod" @click.self="topage(2, '/specialService')">
              {{ $t("header[17]") || "特色服务" }}
            </div>
          </div>
        </li>
        <li
          @click.self="topage(3, '/medicalNetwork')"
          @mouseenter.self="hover(3)"
          @mouseleave="leave(3)"
          :class="[languageText === 'English' ? 'en-li' : '']"
        >
          {{ $t("header[3]") || "医疗网络" }}
        </li>
        <li
          @mouseenter.self="hover(4)"
          @mouseleave="leave(4)"
          :class="[languageText === 'English' ? 'en-li' : '']"
        >
          {{ $t("header[4]") || "医疗服务" }}
          <div class="childs">
            <div  v-if="!enLang" class="prod" @click.self="topage(4, '/medicalService/clinic/yihui')">
              {{ "中间带·宜汇" }}
            </div>
            <div  v-if="!enLang" class="prod" @click.self="topage(4, '/medicalService/clinic/bainuo')">
              {{ "中间带·百诺" }}
            </div>
            <div  v-if="!enLang" class="prod" @click.self="topage(4, '/medicalService/clinic/lippo')">
              {{ "中间带·丽铂医疗美容" }}
            </div>
            <div  v-if="!enLang" class="prod" @click.self="topage(4, '/medicalService/clinic/shenzhen')">
              {{ "中间带·深圳旗舰店" }}
            </div>
            <div  v-if="!enLang" class="prod" @click.self="topage(4, '/medicalService/clinic/chendu')">
              {{ "中间带·成都旗舰店" }}
            </div>
            <div
              class="prod"
              @click.self="topage(4, '/medicalService/company')"
            >
              {{ $t("header[19]") || "企业健保服务" }}
            </div>
          </div>
        </li>
        <li
          @click.self="topage(5, '/about')"
          @mouseenter.self="hover(5)"
          @mouseleave="leave(5)"
        >
          {{ $t("header[5]") || "关于我们" }}
        </li>
        <li></li>
        <li v-show="!enLang" @mouseenter.self="hover(7)" @mouseleave="leave(7)">
          {{ languageText }} 
          <img class="down" :src="downIcon" alt="" />
          <div class="childs">
            <div class="prod" @click="changeLangEvent('zh-cn')">中文 CN</div>
            <div class="prod" @click="changeLangEvent('en-us')">英文 EN</div>
          </div>
        </li>
        <li @mouseenter.self="hover(8)" @mouseleave="leave(8)">
          {{ $t("header[6]") || "登陆" }}
          <img class="down" :src="downIcon" alt="" />
          <div v-if="!enLang" class="childs">
            <a
              href="https://provider.medilink-global.com.cn/pcadmin/loginPage"
              target="_blank"
              ><div class="prod" >{{ $t("header[20]") || "会员登录" }}</div></a
            >
            <a
              href="https://provider.medilink-global.com.cn/login"
              target="_blank"
            >
              <div class="prod">
                {{ $t("header[21]") || "医疗机构登陆" }}
              </div></a
            >
            <a
              href="https://secure.medilink-global.com.cn/eccs/"
              target="_blank"
            >
              <div class="prod">
                {{ $t("header[22]") || "合作伙伴登陆" }}
              </div></a
            >
          </div>
          <div v-else class="childs">
            <div class="prod" >{{ $t("header[20]") || "会员登录" }}</div>
            <div class="prod">
              {{ $t("header[21]") || "医疗机构登陆" }}
            </div>
            <div class="prod">
              {{ $t("header[22]") || "合作伙伴登陆" }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  components: {},
  data() {
    return {
      logoImg: require("@/assets/imgs/layout/logo.png"),
      downIcon: require("@/assets/imgs/layout/down.png"),
      currentIndex: 0,
      languageText: "中文",
      isYtEnv: false,
    };
  },
  computed: {
    enLang() {
      // 如果值为en 展示逻辑变更，不显示中英切换
      const flag = sessionStorage.getItem('lang') === 'en'
      return flag
    }
  },
  watch: {
    enLang: {
      handler(val) {
        if(val && localStorage.getItem("locale") !== "en-us") {
          this.changeLangEvent('en-us')
        }
      },
      immediate: true,
    }
  },
  created() {
    if (this.$i18n.locale == "en-us") {
      this.languageText = "English";
    } else {
      this.languageText = "中文";
    }
    //判断域名，是否是
    const currentHost = window.location.host;
    if (currentHost === "yutai365.com") {
      this.isYtEnv = true;
    }
  },
  mounted() {
    if (this.$i18n.locale == "en-us" && this.$route.path === "/index") {
      this.topage(0, "/");
    }

    let cursor = this.$refs["cursor"];
    let cursorCurrent = this.$refs["cursor-current"];

    this.$i18n.locale == "en-us" ? (cursor.style.left = "4px") : "";
    this.$i18n.locale == "en-us" ? (cursorCurrent.style.left = "4px") : "";
  },
  methods: {
    changeLangEvent(language) {
      if (localStorage.getItem("locale") != language) {
        this.$router.go(0);
      }
      if (language === "en-us") {
        localStorage.setItem("locale", "en-us");
        this.$i18n.locale = localStorage.getItem("locale"); //关键语句
        this.languageText = "English";
      } else {
        localStorage.setItem("locale", "zh-cn");
        this.$i18n.locale = localStorage.getItem("locale"); //关键语句
        this.languageText = "中文";
      }
    },

    topage(index, url) {
      let cursor = this.$refs["cursor"];
      this.currentIndex = index;
      let cursorCurrent = this.$refs["cursor-current"];

      switch (index) {
        case 0:
          this.$i18n.locale === "en-us"
            ? (cursor.style.left = "4px")
            : (cursor.style.left = "0");
          this.$i18n.locale === "en-us"
            ? (cursorCurrent.style.left = "4px")
            : (cursorCurrent.style.left = "0");
          break;
        case 1:
          this.$i18n.locale === "en-us"
            ? (cursor.style.left = "116px")
            : (cursor.style.left = "124px");

          break;
        case 2:
          this.$i18n.locale === "en-us"
            ? (cursor.style.left = "320px")
            : (cursor.style.left = "284px");
          break;
        case 3:
          this.$i18n.locale === "en-us"
            ? (cursor.style.left = "528px")
            : (cursor.style.left = "448px");
          break;
        case 4:
          this.$i18n.locale === "en-us"
            ? (cursor.style.left = "685px")
            : (cursor.style.left = "586px");
          break;
        case 5:
          this.$i18n.locale === "en-us"
            ? (cursor.style.left = "785px")
            : (cursor.style.left = "728px");
          break;
      }

      let childs = this.$el.querySelectorAll(".childs");
      // 关闭弹窗
      childs.forEach((item) => {
        item.style.display = "none";
      });
      // 跳页面
      if (url === 'MedilinkGlobalAssist') {
        window.location.href = "http://www.medilink-globalassist.com/home";
      } else {
        this.$router.push(url);
      }
    },
    leave() {
      let cursor = this.$refs["cursor"];
      let cursorCurrent = this.$refs["cursor-current"];
      let childs = this.$el.querySelectorAll(".childs");
      childs.forEach((item) => {
        item.style.display = "none";
      });
      switch (this.currentIndex) {
        case 0:
          this.$i18n.locale === "en-us"
            ? (cursor.style.left = "4px")
            : (cursor.style.left = "0");
          this.$i18n.locale === "en-us"
            ? (cursorCurrent.style.left = "4px")
            : (cursorCurrent.style.left = "0");
          break;
        case 1:
          this.$i18n.locale === "en-us"
            ? (cursor.style.left = "116px")
            : (cursor.style.left = "124px");

          this.$i18n.locale === "en-us"
            ? (cursorCurrent.style.left = "116px")
            : (cursorCurrent.style.left = "124px");

          break;
        case 2:
          this.$i18n.locale === "en-us"
            ? (cursor.style.left = "320px")
            : (cursor.style.left = "284px");
          this.$i18n.locale === "en-us"
            ? (cursorCurrent.style.left = "320px")
            : (cursorCurrent.style.left = "284px");

          break;
        case 3:
          this.$i18n.locale === "en-us"
            ? (cursor.style.left = "528px")
            : (cursor.style.left = "448px");
          this.$i18n.locale === "en-us"
            ? (cursorCurrent.style.left = "528px")
            : (cursorCurrent.style.left = "448px");

          break;
        case 4:
          this.$i18n.locale === "en-us"
            ? (cursor.style.left = "685px")
            : (cursor.style.left = "586px");
          this.$i18n.locale === "en-us"
            ? (cursorCurrent.style.left = "685px")
            : (cursorCurrent.style.left = "586px");

          break;
        case 5:
          this.$i18n.locale === "en-us"
            ? (cursor.style.left = "785px")
            : (cursor.style.left = "728px");
          this.$i18n.locale === "en-us"
            ? (cursorCurrent.style.left = "785px")
            : (cursorCurrent.style.left = "728px");

          break;
      }
    },
    hover(index) {
      let childs = this.$el.querySelectorAll(".childs");
      // 游标
      let cursor = this.$refs["cursor"];
      let cursorCurrent = this.$refs["cursor-current"];
      cursor.style.display = "show";
      cursorCurrent.style.display = "show";
      switch (index) {
        case 0:
          this.$i18n.locale === "en-us"
            ? (cursorCurrent.style.left = "4px")
            : (cursorCurrent.style.left = "0");
          break;
        case 1:
          this.$i18n.locale === "en-us"
            ? (cursorCurrent.style.left = "116px")
            : (cursorCurrent.style.left = "124px");
          childs[0].style.display = "block";
          this.$i18n.locale === "en-us"
            ? (childs[0].style.left = "-114px")
            : "";
          break;
        case 2:
          this.$i18n.locale === "en-us"
            ? (cursorCurrent.style.left = "320px")
            : (cursorCurrent.style.left = "284px");
          childs[1].style.display = "block";

          this.$i18n.locale === "en-us" ? (childs[1].style.left = "-30px") : "";

          break;
        case 3:
          this.$i18n.locale === "en-us"
            ? (cursorCurrent.style.left = "528px")
            : (cursorCurrent.style.left = "448px");
          break;
        case 4:
          this.$i18n.locale === "en-us"
            ? (cursorCurrent.style.left = "685px")
            : (cursorCurrent.style.left = "586px");
          childs[2].style.display = "block";
          this.$i18n.locale === "en-us" ? (childs[2].style.left = "-74px") : "";
          break;
        case 5:
          this.$i18n.locale === "en-us"
            ? (cursorCurrent.style.left = "785px")
            : (cursorCurrent.style.left = "728px");
          break;
        case 7:
          childs[3].style.display = "block";
          break;
        case 8:
          childs[4].style.display = "block";
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  min-width: 1440px;
  display: flex;
  justify-content: space-between;
  background: #2c2c31;
  .logo {
    padding: 17px 47px;
    img {
      width: 120px;
    }
  }
  .menu-container {
    position: relative;
    .cursor {
      width: 29px;
      height: 3px;
      background: white;
      position: absolute;
      bottom: 0;
    }
    .menu {
      display: flex;
      justify-content: space-evenly;
      color: white;
      line-height: 63px;
      margin: 0;
      .en-li {
        margin-right: 44px;
      }
      li {
        .down {
          width: 6px;
          height: 5px;
          margin-left: 8px;
          position: relative;
          top: -2px;
        }
        position: relative;
        cursor: pointer;
        margin-right: 84px;
        font-size: 14px;

        .childs {
          display: none;
          background: white;
          position: absolute;
          white-space: nowrap;

          border-radius: 0px 0px 14px 14px;
          padding: 20px 28px;
          color: #666666;
          font-size: 14px;
          top: 63px;
          left: -34px;
          z-index: 9999;
          color: #666666;
          .prod {
            margin: 0;
            line-height: 28px;
            text-align: center;
            &:hover {
              color: #000000;
            }
          }
        }
        :nth-child(6) {
          margin-right: 67px;
        }
        &:nth-child(2) {
          .childs {
            left: -58px;
            .prod {
              &:nth-child(1),
              &:nth-child(3) {
                font-weight: bold;
              }
            }
          }
        }
        &:nth-child(3) {
          .childs {
            left: -30px;
            .prod {
            }
          }
        }
        &:nth-child(5) {
          .childs {
            left: -44px;
            .prod {
            }
          }
        }
        &:nth-child(8) {
          .childs {
            left: -30px;
            .prod {
              width: 52px;
            }
          }
        }
        &:nth-child(9) {
          a {
            color: #666666;
          }
          .childs {
            left: -46px;
            padding: 20px 0;
            .prod {
              width: 140px;
              text-align: center;
            }
          }
        }
        &:nth-child(7) {
          width: 1px;
          background: white;
          height: 19px;
          position: relative;
          top: 25px;
          margin-right: 34px;
          margin-right: 67px;
        }
        &:nth-child(8) {
          margin-right: 34px;
        }
        &:nth-child(9) {
          margin-right: 49px;
        }
      }
    }
  }
}
</style>
